module.exports = __webpack_public_path__ + "img/title-4.c067fe86.png";